/* eslint-disable no-unused-vars */
import React, { Suspense, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Form, Input, Label } from 'reactstrap';
import logoDark from '../../assets/images/naamloos.svg';

//Import Icons
// import FeatherIcon from 'feather-icons-react';

// // import images
// import americanEx from '../../../assets/images/payments/american-ex.png';
// import discover from '../../../assets/images/payments/discover.png';
// import masterCard from '../../../assets/images/payments/master-card.png';
// import paypal from '../../../assets/images/payments/paypal.png';
// import visa from '../../../assets/images/payments/visa.png';

//Import Images

//Import Switcher
// import BackToTop from "../../../components/Layout/backToTop";
import {
  ArrowUp,
  Facebook,
  Instagram,
  Linkedin,
  Mail,
  Twitter,
} from 'react-feather';
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterIcon,
  TwitterShareButton,
} from 'react-share';
import { FaSquareXTwitter } from 'react-icons/fa6';
import TermsAndConditions from './../DemoShop/Shop/termsAndCondition';
import { useTranslation } from 'react-i18next';
const BackToTop = () => {
  const toTop = () => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  window.onscroll = function () {
    backToTopButton();
  };

  function backToTopButton() {
    var ele = document.getElementById('back-to-top');
    if (ele) {
      if (
        document.body.scrollTop > 100 ||
        document.documentElement.scrollTop > 100
      ) {
        ele.style.display = 'block';
      } else {
        ele.style.display = 'none';
      }
    }
  }
  return (
    <React.Fragment>
      <Link
        to="#"
        onClick={() => toTop()}
        id="back-to-top"
        className="btn btn-icon btn-primary back-to-top"
        style={{ display: 'none' }}
      >
        {/* <FeatherIcon icon="arrow-up" className="icons" /> */}
        <ArrowUp className="icons" />
      </Link>
    </React.Fragment>
  );
};
const Loader = () => {
  return (
    <div id="preloader">
      <div id="status">
        <div className="spinner">
          <div className="double-bounce1"></div>
          <div className="double-bounce2"></div>
        </div>
      </div>
    </div>
  );
};

const Footer = (isLight = true) => {
  const { t } = useTranslation();
  const [modal, setModal] = useState();
  const year = new Date();
  const grid1 = [
    { title: t('nav_item1'), link: '/' },
    { title: t('nav_item5'), link: '/about-us' },
    { title: t('nav_item3'), link: '/blog' },
    { title: t('Faq'), link: '/faq' },
  ];
  const grid2 = [
    // { title: 'Contact us', link: '/contact-us' },
  ];
  const url = 'https://werkenindezwembadbranche.nl/';
  const title = 'werkenindezwembadbranche';
  const hashtags = ['#web'];

  useEffect(() => {
    const sections = document.querySelectorAll('.fade-in');
    const callback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
        }
      });
    };
    const observer = new IntersectionObserver(callback);
    sections.forEach((section) => {
      observer.observe(section);
    });
    return () => {
      sections.forEach((section) => {
        observer.unobserve(section);
      });
    };
  }, []);
  return (
    <React.Fragment>
      <Suspense fallback={Loader()}>
        <footer className="footer fade-in">
          <Container>
            <Row>
              <Col className="col-12">
                <div className="footer-py-60 pb-4">
                  <Row className="g-4">
                    <Col
                      className="col-12 mt-4 d-flex justify-content-center mt-sm-0 pt-2 pt-sm-0"
                      name="footercolumn"
                    >
                      <div>
                        <Link
                          to="/"
                          className="logo-footer d-flex flex-column gap-2 text-center"
                        >
                          <img
                            src={logoDark}
                            height="70"
                            alt=""
                            className="rounded-circle mx-auto"
                          />
                          Werken in de zwembadbranche
                        </Link>

                        <div className=" mt-4 gap-sm-3 gap-3 d-flex flex-wrap justify-content-center">
                          {grid1.map((grid, key) => (
                            <Link
                              key={key}
                              to={grid.link}
                              className={isLight ? '' : ''}
                              style={{ textTransform: 'capitalize' }}
                            >
                              {grid.title.toLowerCase()}{' '}
                              {grid1?.length - 1 !== key && (
                                <span className="ms-sm-3 ms-3">|</span>
                              )}
                            </Link>
                          ))}
                        </div>
                        <div className="d-flex gap-3 mt-3 flex-wrap justify-content-center">
                          <FacebookShareButton url={url}>
                            <FacebookIcon size={32} round={true} />
                          </FacebookShareButton>
                          <LinkedinShareButton url={url}>
                            <LinkedinIcon size={34} round={true} />
                          </LinkedinShareButton>
                          <TwitterShareButton
                            url={url}
                            title={title}
                            hashtags={hashtags}
                          >
                            <FaSquareXTwitter size={30} />
                          </TwitterShareButton>
                        </div>
                        <div className="text-center mt-3 ">
                          Info:{' '}
                          <Link
                            to={'mailTo: support@werkenindezwembadbranche.nl'}
                          >
                            support@werkenindezwembadbranche.nl
                          </Link>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Container>

          <div
            className="py-3 footer-bar"
            style={{ borderTop: '1px solid #cacaca' }}
          >
            <Container fluid={'xxl'} className="">
              <div className="d-flex justify-content-md-between flex-md-row flex-column  justify-content-md-center align-items-center gap-3">
                <div className="d-flex align-items-center justify-content-center gap-md-3 gap-4 flex-wrap ">
                  <Link onClick={() => setModal(true)} className="rounded ">
                    {t('TnC')}
                  </Link>
                  <Link to="/faq" className="rounded ">
                    {t('Faq')}
                  </Link>
                  <Link to="/privacy-policy" className="rounded ">
                    {t('privacyPolicy')}
                  </Link>
                </div>
                <div className="">
                  @{year.getFullYear()} werkenindezwembadbranche
                </div>
              </div>
            </Container>
          </div>
        </footer>

        <BackToTop />
        <TermsAndConditions setModal={setModal} modal={modal} />
      </Suspense>
    </React.Fragment>
  );
};

export default Footer;
